export enum UserRole {
    ADMIN = 'admin',
    SUPER_ADMIN = 'super admin',
    STORE_MANAGER = 'store manager',
    USER = 'user',
    PROCUREMENT_MANAGER = 'procurement manager',
    BUSINESS_LEADER = 'business leader',
    DATA_STRATEGIST = 'data strategist',
    DIVISIONAL_MANAGER = 'divisional manager',
    OPS_EXECUTIVE = 'ops executive',
}
